import { render, staticRenderFns } from "./TaxiInfoPanel.vue?vue&type=template&id=c8997dfa&scoped=true&lang=pug"
import script from "./TaxiInfoPanel.vue?vue&type=script&lang=js"
export * from "./TaxiInfoPanel.vue?vue&type=script&lang=js"
import style0 from "./TaxiInfoPanel.vue?vue&type=style&index=0&id=c8997dfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8997dfa",
  null
  
)

export default component.exports